<script>
import Vue from 'vue'
import _ from 'lodash'

import DocAPI from '@/views/docs/DocAPI'
import DocCode from '@/views/docs/DocCode'
import DocImage from '@/views/docs/DocImage'
import DocImageGrid from '@/views/docs/DocImageGrid'
import DocTable from '@/views/docs/DocTable'
import DocText from '@/views/docs/DocText'

Vue.component('doc-api', DocAPI)
Vue.component('doc-code', DocCode)
Vue.component('doc-image', DocImage)
Vue.component('doc-image-grid', DocImageGrid)
Vue.component('doc-table', DocTable)
Vue.component('doc-text', DocText)

export default {
  computed: {
    title() {
      return this.data.title
    }
  },
  methods: {
    get_entry_type: _.memoize(type => {
      return `doc-${type}`
    })
  },
  name: 'doc',
  props: {
    data: {type: Object, default: () => null}
  }
}
</script>

<template>
<div class='doc d-flex flex-column' :key='data.title'>
  <div class='display-1 font-weight-bold mb-4'>{{title}}</div>
  <component v-for='(e, i) in data.entries' :key='i'
    :is='get_entry_type(e.type)' v-bind='e'/>
</div>
</template>
